import { render, staticRenderFns } from "./userFeedback.vue?vue&type=template&id=600cdebd"
import script from "./userFeedback.vue?vue&type=script&lang=js"
export * from "./userFeedback.vue?vue&type=script&lang=js"
import style0 from "./userFeedback.vue?vue&type=style&index=0&id=600cdebd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports